import { QueryNode } from '../Query/TypedNode'
import { QueryModel } from '../Query/ViewModel'
import { QueryJSCodeDefinition } from './TypedDefinition'

import type { JavaScriptNode, JavaScriptSpecific } from '../JavaScript'
import type { QuerySpecificLike } from '../Query/TypedNode'

export interface QueryJSCodeSpecific extends QuerySpecificLike {
  props?: {
    script?: JavaScriptSpecific
  }
  type: 'Query.JSCode'
}

export class QueryJSCodeNode extends QueryNode {
  override props: {
    script?: JavaScriptNode
  } = {}
}

export class QueryJSCodeModel extends QueryModel {
  static override definition = QueryJSCodeDefinition

  static override node = QueryJSCodeNode
  override async resolver(): Promise<any> {
    const node = this.__r_node as QueryJSCodeNode
    if (node.props.script?.error !== undefined) throw node.props.script?.error
    return await this.props.script?.()
  }
}

declare global {
  export interface RehajeSpecifics {
    'Query.JSCode': QueryJSCodeSpecific
  }
  export interface RehajeTypedNodes {
    'Query.JSCode': QueryJSCodeNode
  }
}
